import type { ScheduledPostTarget } from 'types'
import {
  PLATFORM_CHARACTER_LIMITS,
  checkPlatformViolation,
  type PlatformLimits,
} from 'components/ValidationBanner/utils'

export const hasContentWarning = (target: ScheduledPostTarget): boolean => {
  const platform = target.provider as PlatformLimits | undefined
  if (!platform || !(platform in PLATFORM_CHARACTER_LIMITS)) return false
  const caption = (target.target_overrides?.content as string | undefined) ?? ''
  return checkPlatformViolation(caption, platform) !== null
}
